import _curryN from './_curryN'

/**
 * @see _curryN
 */
const _curry2 = _curryN(2)

export default _curry2